import React from 'react';
import { Card } from 'antd';
import PayoutSetting from './PayoutSetting';

function PayoutSettingsLayout() {
    return (
        <Card style={{borderRadius: 0, margin: '20px'}}>
            <PayoutSetting isFromConnector={false} />
        </Card>
    );
}

export default PayoutSettingsLayout;